import HeadTittle from '../../../../../../components/HeadTittle';
import ButtonIcon from '../../../../../../components/buttons/ButtonIcon';
import {
    AddIcon,
    CleanIcon,
    EditIcon,
    PersonChipBlack
} from '../../../../../../components/buttons/IconButtons';
import { permissionObj } from '../../../../../../Helpers/permission';
import ButtonAction from '../../../../../../components/buttons/ButtonAction';
import DivContainerBody from '../../../../../../components/DivContainerBody';
import { CustomTextField } from '../../../../../../components/CustomTextField';
import DividerWithText from '../../../../../../components/DividerWithText';
import {
    getModelSimpleSearch,
    userListToLabelEmailPhoneValue
} from '../../../../../../Apis/functions';
import CustomAddChipSearch from '../../../../../../components/CustomAddChipSearch';
import { USER_TYPE_MODEL } from '../../../../../../enums/userTypeEnum';
import React from 'react';
import AddEditShiftAccessApp from './Functionality/AddEditShiftAccessApp';
import { TABLES } from '../../../../../../Apis/Tables';
import {SERVICE_SEARCH_DEVICES} from '../../../../../../reduxToolkit/Commons/CommonsApi';
import {MODE_MODEL} from '../../../../Devices/Model/Model';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const AddEditShiftAccess = () => {

    const {
        id,
        t,
        DEV,
        permission,
        item,
        disabled,
        emptyFields,
        devices, setDevices,
        user, setUser,
        departments, setDepartments,
        handleChange,
        handleAddEdit,
        handleClearFields,
        handleOnBack
    } = AddEditShiftAccessApp();

    return (
        <>
            <HeadTittle
                onBack={handleOnBack}
                name={id ? 'update' : 'create'}
                divStack={!id ?
                    <div className={"ml-1"}>
                        <ButtonIcon
                            id='btn_aes_clean_fields'
                            Icon={CleanIcon}
                            onClick={handleClearFields}
                            title={'clear_instances'}
                            className={"btn-clean-secondary-600"}
                            tooltipPlacement={"right"}
                            iconProps='btn-icon-svg-12px icon-color-general-00'
                        />
                    </div>
                    : null
                }
            >
                {(DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_SHIFT_CREATE)) &&
                    <ButtonAction
                        id='btn_aes_update_data'
                        name={id ? 'update' : 'create'}
                        className='btn-icon-edit'
                        Icon={id ? EditIcon : AddIcon}
                        onClick={() => {
                            handleAddEdit();
                        }}
                    />
                }
            </HeadTittle>
            <DivContainerBody>
                <div className='row mt-4'>
                    <div className='col-12'>
                        <CustomTextField
                            id='txt_aesa_name'
                            name='name'
                            value={item?.name}
                            trans='name'
                            type='text'
                            disabled={disabled}
                            onChange={handleChange}
                            emptyFields={emptyFields}
                            required={true}
                            length={64}
                        />
                    </div>

                    <div className='col-12 mb-3'>
                        <DividerWithText title={t('devices_access')} />
                    </div>

                    <div className='col-12'>
                        <CustomAddChipSearch
                            id="atc_aesa_devices_access"
                            selectedList={devices}
                            setSelectedList={setDevices}
                            disabled={false}
                            label="device"
                            required={true}
                            reset={false}
                            hideButton={false}
                            keyId={"id"}
                            showSubSection={false}
                            sanitizeDataList={userListToLabelEmailPhoneValue}
                            chipIcon={null}
                            Icon={null}
                            api={SERVICE_SEARCH_DEVICES}
                            bodyApi={getModelSimpleSearch("", {modeIds: [MODE_MODEL.ATTENDANCE, MODE_MODEL.ACCESS_AND_ATTENDANCE]})}
                            emptyFields={emptyFields && devices.length <= 0}
                        />
                    </div>

                    <div className='col-12 my-3'>
                        <DividerWithText title={t('departments')} />
                    </div>

                    <div className='col-12'>
                        <CustomAddChipSearch
                            id="atc_aesa_departments"
                            selectedList={departments}
                            setSelectedList={setDepartments}
                            disabled={false}
                            label="department"
                            required={false}
                            reset={false}
                            hideButton={false}
                            keyId={"id"}
                            showSubSection={false}
                            sanitizeDataList={userListToLabelEmailPhoneValue}
                            chipIcon={null}
                            Icon={null}
                            bodyApi={getModelSimpleSearch(TABLES.DEPARTMENT)}
                        />

                    </div>
                    <div className='col-12 my-3'>
                        <DividerWithText title={t('custom_access')} />
                    </div>

                    <div className='col-12'>
                        <CustomAddChipSearch
                            id="slt_aes_search_users"
                            selectedList={user}
                            setSelectedList={setUser}
                            userTypeIdsSearch={[USER_TYPE_MODEL.EMPLOYEE]}
                            disabled={false}
                            label="name"
                            required={false}
                            reset={false}
                            hideButton={false}
                            keyId={"userId"}
                            showSubSection={true}
                            sanitizeDataList={userListToLabelEmailPhoneValue}
                            Icon={PersonChipBlack}
                        />
                    </div>
                </div>
            </DivContainerBody>
        </>
    )

}

export default AddEditShiftAccess
